import React from 'react'
import { ErrorMessage, Field } from 'formik'

import { FormGroupProps } from '../../types'
import createClassName from '@utils/createClassName'

const FormGroup: React.FC <FormGroupProps> = ({ children, error, inputID, inputRows, inputName, inputType, inputPlaceholder, disabled, label, readonly, onChange, right }) => {

    const inputRef = React.createRef<HTMLInputElement>()

    const inputClasses = createClassName(['formGroup', inputName], [readonly && 'status disabled', error && 'error'])

    const inputProps = {
        id: inputID,
        name: inputName,
        className: readonly ? 'status disabled' : '',
        type: inputType ?? 'text',
        placeholder: inputPlaceholder,
        disabled
    }

    React.useEffect(() => {
        if(inputRef.current && readonly) inputRef.current.setAttribute('readonly', 'readonly')
    }, [inputRef, readonly])

    return(

        <div className = {inputClasses}>
            <label htmlFor = {inputID}>{label}</label>
            <div className = "inputWrapper">
                {children ?? (
                    (inputType === 'textarea' && <Field {...inputProps} innerRef = {inputRef} rows = {inputRows} component = "textarea" onKeyUp = {onChange} />) || <Field {...inputProps} innerRef = {inputRef} onKeyUp = {onChange} />
                )}
                {right}
            </div>
            <ErrorMessage name = {inputName} component = "h6" />
        </div>

    )

}

export default FormGroup